import CustomTooltip from '_components/CustomTooltip';
import { createCustomIcon, mapIcons, transformPoiPropertiesToData } from '_helpers';
import React from 'react';
import { Marker, Popup } from 'react-leaflet';
import { useNavigate } from 'react-router-dom';

function PoiLayer({ poi, type }) {
    
    const customIcon = createCustomIcon(mapIcons(type)+'White', '#6F80FF', 30);
    const navigate = useNavigate()

    let button = null;

    const handleViewFleet = (item) => {
        navigate(`flotte/${item.properties.NOM}`)
    }

    if (type === 'depot') {
        button = {
            label: "VOIR LE DÉTAIL: FLOTTE",
            icon: "viewBusWhite", 
            onClick: () => handleViewFleet(poi),
        }
    }

    return (
        <Marker
            position={poi.geometry.coordinates}
            icon={customIcon}
        >
            <Popup className='custom-tooltip'>
                <CustomTooltip 
                    bg="bg-[#6F80FF]" 
                    data={transformPoiPropertiesToData(poi.properties)} 
                    title={poi.properties.OPERATOR}
                    button={button} 
                />
            </Popup>
        </Marker>
    );
}

export default PoiLayer;